import { render } from "./AddressProgramKpiStats.vue?vue&type=template&id=4cd8f65c"
import script from "./AddressProgramKpiStats.vue?vue&type=script&lang=js"
export * from "./AddressProgramKpiStats.vue?vue&type=script&lang=js"

import "./AddressProgramKpiStats.vue?vue&type=style&index=0&id=4cd8f65c&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__